// PARAQTA — кітапты тізімге қосу / тізімнен алу (кітап беті батырмалары).
// 04.10.26: өлі «Бүгін» (dashboard) модулінен бөлек көшірілді — бет өшті,
// ал бұл екі функцияны кітап беті (events.js 'save-book' / 'unlist-book') қолданады.
//
// Backend MySQL WRITE_DB_USER рұқсаты жоқ болса — 403/503 → тост.

import { toast } from '../../utils/toast.js';
import { showLoginModal } from '../auth/login-modal.js';

// Step BP3: status code → toast мәтіні. 0=оқып жатыр, 1=оқығым келеді, 2=бітірдім.
const STATUS_LABELS = {
  0: '«Оқып жатырмын»',
  1: '«Оқығым келеді»',
  2: '«Аяқтадым»',
};

export async function saveBookToList(title, author, pages, status, btn) {
  if (!window.currentUser) { showLoginModal(); return; }
  // Bookpage hero-да click → толық re-render керек (active state ауысады).
  // Сондықтан мәтіндер мен disabled — тек dashboard контекстінде ғана.
  const isHero = btn && btn.classList.contains('book-status-btn');
  if (btn && !isHero) { btn.disabled = true; btn.textContent = '...'; }
  try {
    const r = await fetch('/api/books/save', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title, author, pages: pages || null, status })
    });
    if (r.ok) {
      const d = await r.json();
      const label = STATUS_LABELS[status] || '';
      if (d.action === 'exists') toast('Тізімде бар!');
      else toast('✓ ' + label + ' тізіміне қосылды');
      if (isHero) {
        // Hero-ні re-render: openBookPage қайта шақыру user_status жаңартады
        // + active button switches. Slug location.hash-те.
        const slug = (location.hash || '').replace(/^#book\//, '');
        if (slug && typeof window.openBookPage === 'function') window.openBookPage(slug);
      } else if (btn) {
        btn.textContent = '✓ ' + label;
        btn.style.opacity = '.6';
      }
    } else if (r.status === 403 || r.status === 503) {
      toast('⚠️ Жазба рұқсаты жоқ');
      if (btn && !isHero) { btn.disabled = false; }
    }
  } catch(e) {
    toast('Желі қатесі');
    if (btn && !isHero) { btn.disabled = false; }
  }
}

// Step BP3: Toggle off — bookpage-та active батырманы қайта басу
// status-ты тізімнен алады (DELETE). user_status null болады.
export async function unlistBook(title, btn) {
  if (!window.currentUser) { showLoginModal(); return; }
  try {
    const r = await fetch('/api/books/unlist', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title })
    });
    if (r.ok) {
      toast('✓ Тізімнен алынды');
      const slug = (location.hash || '').replace(/^#book\//, '');
      if (slug && typeof window.openBookPage === 'function') window.openBookPage(slug);
    } else if (r.status === 403 || r.status === 503) {
      toast('⚠️ Жазба рұқсаты жоқ');
    }
  } catch(e) {
    toast('Желі қатесі');
  }
}
